import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { painCards } from '../../data/salesContent';
export function ProblemSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-185" data-mp="8lbq2npd4m0h">
      <div className="mx-auto max-w-6xl" data-id="element-186" data-mp="8kjv9f3lasb9">
        <SectionHeading title="¿Cuántas horas más vas a perder preparando cada capacitación?" data-id="element-187" data-mp="djd7z5b1yfad" />
        <div className="mx-auto mt-10 max-w-3xl text-center" data-id="element-188" data-mp="3vprj6whxsb52">
          <p className="text-2xl font-bold text-cream md:text-3xl" data-id="element-189" data-mp="3vrm78joi8jdd">Sabés primeros auxilios.</p>
          <p className="mt-4 text-lg leading-relaxed text-neutral-400 md:text-xl" data-id="element-190" data-mp="3n1uwd3n1lev">
            El problema aparece cuando tenés que transformar ese conocimiento en una clase clara, práctica y evaluable.
          </p>
          <p className="mt-8 rounded-2xl border border-gold/40 bg-ink-soft px-6 py-5 font-display text-xl font-black uppercase leading-snug text-cream md:text-2xl" data-id="element-191" data-mp="3qs9jzxtq1aa9">
            No te falta conocimiento. <span className="text-gold" data-id="element-192" data-mp="1owz4jbj8rj5x">Te falta un sistema.</span>
          </p>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-193" data-mp="1nlqccrtruh4i">
          {painCards.map(p => <li key={p} className="flex items-start gap-4 rounded-2xl border border-ink-line bg-ink-raised p-6" data-id="element-194" data-mp="1imx87q0dk2h0">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-red-400/40 text-red-400" data-id="element-195" data-mp="1sejjtngmk3ka">
                <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-196" data-mp="14q06uummr2lv" />
              </span>
              <span className="text-lg font-medium leading-snug text-cream" data-id="element-197" data-mp="zqxd46c3oit7">{p}</span>
            </li>)}
        </ul>

        <div className="mt-14 text-center" data-id="element-198" data-mp="1dqyedmwa1s97">
          <p className="text-lg text-neutral-400 md:text-xl" data-id="element-199" data-mp="18qtz2073v3kk">Y cuando terminás una capacitación...</p>
          <p className="mt-3 font-display text-2xl font-black uppercase leading-tight text-cream md:text-3xl" data-id="element-200" data-mp="2p4am48v5qv0n">
            En la siguiente volvés a hacer <span className="text-gold" data-id="element-201" data-mp="2k57dyfjvs8og">gran parte del trabajo.</span>
          </p>
        </div>
      </div>
    </section>;
}